<template>
  <b-container fluid>
    <backlink />
    <h1>Agences</h1>

    <AdminTable :config="config"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "AgencyList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Agency/AgencyList.vue